var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showElement,
          expression: "showElement",
        },
      ],
      staticClass: "destination-list-card",
      on: {
        keypress: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.destinationSelected(_vm.item)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.destinationSelected(_vm.item)
          },
        ],
      },
    },
    [
      _c("div", { staticClass: "destination-list-card-label" }, [
        _c("label", { attrs: { for: _vm.item.value, tabindex: "0" } }, [
          _c("span", {
            staticClass: "destination-name",
            domProps: {
              innerHTML: _vm._s(
                _vm.parsedPropertyName ? _vm.parsedPropertyName : _vm.item.label
              ),
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _vm.localValue
        ? _c("span", {
            staticClass: "destination-list-card-icon icon-checkmark-circle",
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "destination-list-card-checkbox" }, [
        _c("input", {
          key: JSON.stringify(_vm.item) + "checkbox",
          ref: "checkbox",
          attrs: {
            id: _vm.item.value,
            type: "checkbox",
            name: "interest-" + _vm.item.value,
            "data-field-type": "CheckBoxSet",
          },
          domProps: { value: _vm.item.value, checked: !!_vm.localValue },
          on: {
            keypress: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.destinationSelected(_vm.item)
            },
            input: function ($event) {
              return _vm.destinationSelected(_vm.item)
            },
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }